/**
 * 组件类型固定 ID（6 位纯数字，类似组件名）。
 * 同类型组件 id 相同；实例区分使用 uid，不要用 id。
 *
 * 样式库 1xxxx：标题 11000* / 正文 12000* / 分割线 13000*
 * 组件库 2xxxx：图片 21000* / 音视频 22000* / 跳转链接 23000* / 头部 24000*
 * 支付组件 3xxxx：图片 31000* / 视频 32000* / 音频 32100* / 文件 33000* / 全局 34000* / 付费跳转 35000*
 */

export const BLOCK_ID_BASE = {
	title: 110000,
	body: 120000,
	divider: 130000,
	image: 210000,
	media: 220000,
	qrcodeNav: 230000,
	contact: 230000,
	header: 240000,
	file: 210000,
	payImage: 310000,
	payVideo: 320000,
	payAudio: 321000,
	payFile: 330000,
	payGlobal: 340000,
	payLink: 350000,
};

/**
 * @param {{ category?: string, library?: string, componentCategory?: string, headerComponent?: boolean }} template
 */
export function getBlockIdBase(template = {}) {
	if (template.library === 'component') {
		const cat = template.componentCategory || '';
		if (cat === 'payImage') return BLOCK_ID_BASE.payImage;
		if (cat === 'payVideo') return BLOCK_ID_BASE.payVideo;
		if (cat === 'payAudio') return BLOCK_ID_BASE.payAudio;
		if (cat === 'payFile') return BLOCK_ID_BASE.payFile;
		if (cat === 'payGlobal') return BLOCK_ID_BASE.payGlobal;
		if (cat === 'payLink') return BLOCK_ID_BASE.payLink;
		if (cat === 'header' || template.headerComponent) return BLOCK_ID_BASE.header;
		if (cat === 'qrcodeNav' || cat === 'contact') return BLOCK_ID_BASE.qrcodeNav;
		if (cat === 'media') return BLOCK_ID_BASE.media;
		if (cat === 'file') return BLOCK_ID_BASE.file;
		if (cat === 'image') return BLOCK_ID_BASE.image;
		return BLOCK_ID_BASE.image;
	}

	const styleCat = template.category || '';
	if (styleCat === 'title') return BLOCK_ID_BASE.title;
	if (styleCat === 'body') return BLOCK_ID_BASE.body;
	if (styleCat === 'divider') return BLOCK_ID_BASE.divider;
	return BLOCK_ID_BASE.body;
}

/**
 * 按 TEMPLATE_MAP 声明顺序，为每个 type 分配固定 6 位 id
 * @param {Record<string, object>} templateMap
 * @returns {Record<string, string>}
 */
export function buildFixedBlockIdMap(templateMap = {}) {
	const buckets = new Map();

	Object.values(templateMap).forEach((template) => {
		if (!template?.type) return;
		const base = getBlockIdBase(template);
		if (!buckets.has(base)) {
			buckets.set(base, []);
		}
		buckets.get(base).push(template.type);
	});

	const map = {};
	buckets.forEach((types, base) => {
		types.forEach((type, index) => {
			map[type] = String(base + index + 1).padStart(6, '0');
		});
	});
	return map;
}

/** 获取组件类型的固定 id；无映射时按基数+1 兜底 */
export function getFixedBlockId(type, template, fixedMap = {}) {
	if (fixedMap[type]) return fixedMap[type];
	const base = getBlockIdBase(template || {});
	return String(base + 1).padStart(6, '0');
}

/** 编辑器内实例唯一键：优先 uid */
export function getBlockUid(block = {}) {
	return block.uid || block.id || '';
}
